import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../../../../shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModaleLogoutComponent } from '../../../../../shared/components/modali/modale-logout/modale-logout.component';
import { Capacitor } from '@capacitor/core';

@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './footer.component.html',
	styles: [``],
})
export class FooterComponent implements OnInit {
	router = inject(Router);
	authService = inject(AuthService);
	modalService = inject(NgbModal);
	currentUrl = '';
	isNative = Capacitor.isNativePlatform();

	ngOnInit() {
		this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: any) => {
			this.currentUrl = e.urlAfterRedirects;
		});
		this.currentUrl = this.router.url;
	}


	isActive(path: string): boolean {
		if (path === '/app/dashboard') return this.currentUrl === '/app/dashboard' || this.currentUrl === '/app/dashboard/';
		if (path === '/app/dashboard/profilo') return this.currentUrl.startsWith('/app/dashboard/profilo') && !this.currentUrl.startsWith('/app/dashboard/profilo/storico-pratiche');
		return this.currentUrl.startsWith(path);
	}

	navigate(path: string) {
		this.router.navigate([path]);
	}

	confirmLogout() {
		const modalRef = this.modalService.open(ModaleLogoutComponent, { centered: true, windowClass: 'modal-app-custom' });
		modalRef.result.then((result) => {
			if (result) {
				this.authService.logout();
			}
		}, () => {});
	}
}
